'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var iconTransform = 'scale(0)',
        iconOpacity = 1,
        cursor = 'pointer',
        appearanceMargin = theme.appearanceMargin;

    if (this.props.checked) {
        theme.color = theme.activeColor;
        iconTransform = 'scale(1)';
    }

    if (this.props.error) {
        theme.color = theme.errorColor;
    }

    if (this.props.disabled) {
        theme.color = theme.disabledColor;
        theme.hoverColor = theme.disabledColor;
        iconOpacity = 0.2;
        cursor = 'not-allowed';
    }

    if (!this.props.children && !this.props.label) {
        appearanceMargin = 0;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            position: 'relative',
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            color: theme.color,
            zoom: 1,
            '&:after': {
                clear: 'both',
                content: '""',
                display: 'block',
                height: 0
            }
        },
        description: {
            color: theme.labelColor,
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            width: '100%',
            textAlign: 'left'
        },
        field: {
            display: 'none'
        },
        label: {
            transition: theme.transition,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            cursor: cursor,
            display: 'flex',
            alignItems: 'center',

            '& a': {
                color: theme.color
            },

            '&:hover': {
                color: theme.hoverColor
            }
        },
        labelWrapper: {},
        labelText: {
            paddingRight: theme.paddingRight,
            paddingBottom: theme.paddingBottom,
            paddingTop: theme.paddingTop,
            paddingLeft: theme.paddingLeft,
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            color: theme.color,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight
        },
        icon: {
            position: 'relative',
            width: '18px',
            height: '18px',
            boxSizing: 'border-box',
            border: '2px solid ' + theme.appearanceBorderColor,
            borderRadius: '50%',
            opacity: iconOpacity,

            '&:after': {
                transition: 'all 250ms cubic-bezier(1, 1.7, 0, 1) 0ms',
                display: 'block',
                content: '""',
                width: '18px',
                height: '18px',
                backgroundImage: theme.appearanceImage,
                position: 'absolute',
                top: '-2px',
                left: '-2px',
                transform: iconTransform
            }
        },
        iconWrapper: {
            position: 'relative',
            margin: appearanceMargin,
            padding: theme.iconPadding
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        icon: (0, _aphroditeJss.css)(styleList.icon),
        labelText: (0, _aphroditeJss.css)(styleList.labelText),
        labelWrapper: (0, _aphroditeJss.css)(styleList.labelWrapper),
        label: (0, _aphroditeJss.css)(styleList.label),
        field: (0, _aphroditeJss.css)(styleList.field),
        description: (0, _aphroditeJss.css)(styleList.description),
        iconWrapper: (0, _aphroditeJss.css)(styleList.iconWrapper)
    };
};

var _radio_active = require('../img/radio_active.svg');

var _radio_active2 = _interopRequireDefault(_radio_active);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        display: 'inline-block',
        appearanceImage: 'url("' + _radio_active2.default + '")',
        appearanceBorderColor: theme.elSecondary,
        color: theme.tLabel,
        fontSize: theme.tsNormal,
        lineHeight: 1.5,
        fontFamily: theme.fontFamily,
        transition: theme.mainTransition,
        paddingRight: 0,
        paddingBottom: 0,
        paddingTop: 0,
        paddingLeft: 0,
        appearanceMargin: '0 ' + theme.gutter * 2 + 'px 0 0',
        iconPadding: '3px',

        labelColor: theme.tLabel,
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,

        activeAppearanceBorderColor: theme.elAccent,
        activeColor: theme.tFilled,

        hoverColor: theme.tActive,

        disabledColor: theme.tDisabled,

        errorColor: theme.tError
    };
};